// extracted by mini-css-extract-plugin
module.exports = {"type":"requestItem_type__6VPyg","buttons":"requestItem_buttons__3UkZE","dismissWrapper":"requestItem_dismissWrapper__1gLMC"};